/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import TuneIcon from '@material-ui/icons/Tune';
import { useDependsOnWatcherAccess } from '../controlPanel/useDependsOnWatcherApi';

/**
 * Sidebar entry for the Control Panel. Its tabs read are open to any
 * authenticated user, so the probe only hides the item while signed out (or
 * when the backing plugin is unavailable).
 */
export const ControlPanelSidebarItem = () => {
  const { reachable } = useDependsOnWatcherAccess();
  if (!reachable) return null;
  return <SidebarItem icon={TuneIcon} to="/control-panel" text="Control Panel" />;
};
